import { AgGridReact } from 'ag-grid-react';

// import "ag-grid-enterprise/styles/ag-theme-quartz.css";
import { useCallback, useEffect, useRef, useState } from 'react';
import { Clause } from '~/api/def/endpoints/obligationsEndpoint';
import { colDefsObligationsTable } from '~/components/ui/tables/ag/obligationsTable/colDefsObligationsTable';
import { colTypesWidths } from '~/components/ui/tables/ag/columnTypes';
import {
  Breadcrumb,
  BreadcrumbProps,
} from '~/components/ui/layout/navigation/breadcrumb/Breadcrumb';
import { Hierarchy } from '~/types';
import { getHierarchyPath } from '~/lib/fund/getHierarchyPath';
import { agTheme } from '~/components/ui/tables/ag/agTheme';
import { useNavigate } from '@tanstack/react-router';
import { getObligationsContextMenu } from '~/components/ui/tables/ag/obligationsTable/getOblgationsContextMenu';
import { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid-enterprise';

export type DocumentTableProps = {
  clauses?: Clause[];
  jurisdictionKey?: string;
  hierarchy?: Hierarchy[] | null;
};

export const TableAgObligations = ({
  clauses,
  hierarchy,
  jurisdictionKey,
}: DocumentTableProps) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbProps | undefined>();
  const [countryName, setCountryName] = useState<string | undefined>();
  const gridRef = useRef<AgGridReact<Clause>>(null);
  const navigate = useNavigate();
  const getObligationContextMenuWrapper = useCallback(
    (params: GetContextMenuItemsParams): (string | MenuItemDef)[] => {
      if (navigate) {
        console.log('params', params);
        return getObligationsContextMenu(params, navigate);
      }
      return [];
    },
    [navigate],
  );
  useEffect(() => {
    if (hierarchy && jurisdictionKey) {
      const path = getHierarchyPath({
        hierarchy: hierarchy,
        level: 'jurisdiction',
        jurisdictionKey,
      });
      setCountryName(path?.jurisdiction?.name);

      setBreadcrumbs({
        items: [
          { name: 'Obligations', url: '/obligations' },
          { name: path?.jurisdiction?.name ?? 'not found' },
        ],
      });
    }
  }, [hierarchy, jurisdictionKey]);

  return (
    <div className="flex-column flex h-full">
      <h3>{countryName}</h3>
      <Breadcrumb items={breadcrumbs?.items} />
      <div
        className={'ag-theme-quartz'}
        style={{ width: '100%', height: '100%' }}
      >
        <AgGridReact
          rowData={clauses}
          ref={gridRef}
          // getMainMenuItems={getMainMenuItems}
          getContextMenuItems={getObligationContextMenuWrapper}
          columnDefs={colDefsObligationsTable}
          theme={agTheme}
          columnTypes={colTypesWidths}
          tooltipShowDelay={0}
          suppressCellFocus
          onGridSizeChanged={() => gridRef.current?.api.sizeColumnsToFit()}
          autoSizeStrategy={{
            type: 'fitGridWidth',
            defaultMinWidth: 100,
          }}
        />
      </div>
    </div>
  );
};
